import { Movement } from '@studio/models/ptz';
import { Command } from '#~/command/index.js';

/** Joystick movement. */
export const Joystick: { [K in Command]?: false | { negative: Movement; positive: Movement } } =
  Object.freeze({
    [Command.PTZ_PAN]: { negative: Movement.PanLeft, positive: Movement.PanRight },
    [Command.PTZ_TILT]: { negative: Movement.TiltUp, positive: Movement.TiltDown },
    [Command.PTZ_ZOOM]: { negative: Movement.ZoomIn, positive: Movement.ZoomOut },
    [Command.PTZ_STOP]: false,
    [Command.PTZ_ZOOM_LOCK]: false
  });

/** Quick shots. */
export const QuickShots: { [K in Command]?: Movement | false } = Object.freeze({
  [Command.QUICK_STOP]: false,
  [Command.QUICK_TILT_UP]: Movement.TiltUp,
  [Command.QUICK_TILT_DOWN]: Movement.TiltDown,
  [Command.QUICK_PAN_LEFT]: Movement.PanLeft,
  [Command.QUICK_PAN_RIGHT]: Movement.PanRight,
  [Command.QUICK_ZOOM_IN]: Movement.ZoomIn,
  [Command.QUICK_ZOOM_OUT]: Movement.ZoomOut
});
